import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

export const returnLabelsApi = createApi({
  reducerPath: 'returnLabels',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getReturnLabel: builder.query({
      query: (subscriptionId) => ({
        method: 'GET',
        endpoint: `/subscriptions/${subscriptionId}/return_label`,
      }),
    }),
    getReturnStatus: builder.query({
      query: (subscriptionId) => ({
        method: 'GET',
        endpoint: `/subscriptions/${subscriptionId}/return_status`,
      }),
    }),
  }),
});

export const {
  useGetReturnLabelQuery,
  useLazyGetReturnLabelQuery,
  useGetReturnStatusQuery,
} = returnLabelsApi;
